<template>
  <div class="c-questions-list">
    <template v-for="(question, index) in questions" :key="question.id">
      <!-- <template v-if="questionIndex === index"> -->
      <transition :name="getTransitionName(question)">
        <ion-grid
          v-show="questionIndex === index"
          class="c-questions-list__question"
          :class="{
            '-imagemap': ['painarea', 'spreadarea'].includes(question.type),
          }"
          fixed
          :style="{
            'justify-content': question.text ? 'space-around' : 'flex-start',
          }">
          <!-- <div
            style="min-height: 100%"
            :style="{
              'align-content': question.text ? 'space-around' : 'flex-start',
            }"
          > -->
          <answer-summary
            v-if="question.type === 'answerSummary' && questionIndex === index"
            :files="files"
            :userFiles="userFiles"
            :partnerfiles="partnerFiles"
            :questions="questions"
            :questionsObject="questionsObject"
            :answers="answers"
            :selectedCondition="selectedCondition"
            :selectedSentence="selectedSentence"
            :routing="routing"
            :zahn="zahn"
            :mental="mental"
            :shouldOpenInteliwiseModal="shouldOpenInteliwiseModal"
            :question="question"
            @done="$emit('nextQuestion', $event)"
            @edit-question="$emit('edit-question', $event)"
            @back-to-search="$emit('back-to-search', $event)" />
          <template v-else-if="question.type !== 'answerSummary'">
            <div
              :class="{
                'ion-text-center': ['painarea', 'spreadarea'].includes(
                  question.type
                ),
              }">
              <!-- <div class="ion-text-center"> -->
              <roodie
                v-if="
                  !['explanation', 'privacy', 'contact'].includes(question.type)
                "
                :expression="roodieExpression" />
              <!-- </div> -->
              <h6 v-if="question.text">
                <b v-html="getQuestionText(question)"></b>
              </h6>
              <!-- <ion-row
                            class="ion-align-items-center ion-justify-content-center"
                        >
                            <ion-col size="auto"
                                ><ion-text color="primary"
                                    >Was bedeutet das?</ion-text
                                ></ion-col
                            >
                            <ion-col size="auto">
                                <ion-button
                                    fill="clear"
                                    @click="openInfoModal(question.info)"
                                    size="small"
                                    ><ion-icon
                                        slot="icon-only"
                                        :icon="helpCircle"
                                /></ion-button>
                            </ion-col>
                        </ion-row> -->
              <tooltip
                v-if="question.info"
                :text="getTooltipText(index)"
                :image="getTooltipImage(index)" />
              <tooltip
                v-else-if="
                  question.type === 'slider' &&
                  question.text.toLowerCase().includes('wann')
                "
                text="Klicken Sie auf den Kreis und schieben Sie den Regler zu dem Zeitpunkt, wo Ihre Beschwerden begonnen haben."
                image="calendar.png" />
            </div>
            <div
              v-if="
                [
                  'painarea',
                  'spreadarea',
                  'explanation',
                  'location',
                  'privacy',
                  'contact',
                  'dayTimeSelection',
                  'upload',
                ].includes(question.type)
              "
              :class="{
                'c-questions-list__imagemap': [
                  'painarea',
                  'spreadarea',
                ].includes(question.type),
              }">
              <image-map
                v-if="question.type === 'painarea' && questionIndex === index"
                :question="question"
                :area="
                  genderValue + '-' + selectedArea || selectedCondition.area
                "
                :genderValue="genderValue"
                :selectedCondition="selectedCondition"
                :answersObject="answersObject"
                :shouldStepBack="shouldStepBack"
                @show-info-alt="showInfoAlt = $event"
                @done="$emit('nextQuestion', $event)" />
              <image-map
                v-else-if="
                  question.type === 'spreadarea' && questionIndex === index
                "
                :question="question"
                :area="
                  zahn
                    ? genderValue + '-' + 'body-upper-front'
                    : genderValue + '-' + 'body-front'
                "
                :genderValue="genderValue"
                :herzDiabetes="herzDiabetes"
                :answersObject="answersObject"
                @done="$emit('nextQuestion', $event)" />
              <erklaerung
                v-else-if="question.type === 'explanation'"
                :question="question"
                :routing="routing"
                :selectedCondition="selectedCondition"
                :answersObject="answersObject"
                @done="$emit('nextQuestion', $event)" />
              <location
                v-else-if="
                  question.type === 'location' && questionIndex === index
                "
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <privacy-question
                v-else-if="question.type === 'privacy'"
                :question="question"
                :routing="routing"
                @done="$emit('nextQuestion', $event)" />
              <contact
                v-else-if="question.type === 'contact'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <day-time-selection
                v-else-if="question.type === 'dayTimeSelection'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <upload
                v-else-if="question.type === 'upload'"
                :question="question"
                :selectedCondition="selectedCondition"
                @done="$emit('nextQuestion', $event)" />
            </div>
            <div v-else class="c-questions-list__answer">
              <buttons
                v-if="
                  question.type === 'buttons' || question.type === 'iconButtons'
                "
                :question="question"
                :zahn="zahn"
                @done="$emit('nextQuestion', $event)" />
              <slider
                v-else-if="question.type === 'slider'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <checkbox
                v-else-if="question.type === 'checkbox'"
                :question="question"
                :zahn="zahn"
                @done="$emit('nextQuestion', $event)" />
              <image-buttons
                v-else-if="question.type === 'imageButtons'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <gender
                v-else-if="question.type === 'gender'"
                :person="person"
                @done="$emit('nextQuestion', $event)" />
              <date
                v-else-if="question.type === 'date'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <number-select
                v-else-if="question.type === 'numberSelect'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <text-radio
                v-else-if="question.type === 'textRadio'"
                :question="question"
                :selectedCondition="selectedCondition"
                :answersObject="answersObject"
                :zahn="zahn"
                @done="$emit('nextQuestion', $event)" />
              <date-time-interval
                v-else-if="question.type === 'dateTimeInterval'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <day-time-interval
                v-else-if="question.type === 'dayTimeInterval'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <CGM
                v-else-if="question.type === 'cgm'"
                :question="question"
                @done="$emit('nextQuestion', $event)" />
              <!-- <div v-else class="ion-margin-top">
              Frage wurde noch nicht implementiert.
              <div v-if="question.hint">{{ question.hint }}</div>
              <next-question-button
                @click="
                  $emit('nextQuestion', {
                    value: 'Frage nicht implementiert',
                    id: question.id,
                  })
                "
              />
            </div> -->
            </div>
            <!-- <ion-col v-if="question.id === 'be-96'">
            <div
              class="c-nugget -no-pointer"
              :style="{
                'background-image':
                  'url(' + require('@/assets/img/gradient_lila.svg') + ')',
              }"
            >
              <div class="c-nugget__content">
                <div class="ion-padding-bottom">
                  Ich möchte jetzt gleich ein Arztgespräch führen.*
                </div>
                <div class="c-nugget__buttons ion-margin-top">
                  <ion-button
                    @click="openPhoneMedgateModal"
                    class="u-small"
                    fill="outline"
                    color="light"
                    ><ion-icon :icon="call" slot="start"></ion-icon>Per
                    Telefon</ion-button
                  >
                  <ion-button
                    @click="openVideoMedgateModal"
                    class="u-small"
                    fill="outline"
                    color="light"
                    ><ion-icon :icon="videocam" slot="start"></ion-icon>Per
                    Videoanruf</ion-button
                  >
                </div>
              </div>
            </div>
            <div class="-span u-small ion-margin-top">
              *Ausführender Partner: Medgate Deutschland GmbH
            </div>
          </ion-col> -->
            <!-- </div> -->
          </template>
        </ion-grid>
      </transition>
      <!-- </template> -->
    </template>
  </div>
</template>

<script>
import Buttons from "@lib/components/Questions/Buttons";
import Slider from "@lib/components/Questions/Slider";
import Checkbox from "@lib/components/Questions/Checkbox";
import ImageButtons from "@lib/components/Questions/ImageButtons";
import Gender from "@lib/components/Questions/Gender";
import Date from "@lib/components/Questions/Date";
import NumberSelect from "@lib/components/Questions/NumberSelect";
import ImageMap from "@lib/components/Questions/ImageMap";
import TextRadio from "@lib/components/Questions/TextRadio";
import DateTimeInterval from "@lib/components/Questions/DateTimeInterval";
import DayTimeInterval from "@lib/components/Questions/DayTimeInterval";
import DayTimeSelection from "@lib/components/Questions/DayTimeSelection";
// import NextQuestionButton from "@lib/components/Questions/NextQuestionButton";
import Tooltip from "@lib/components/Tooltip";
import Erklaerung from "@lib/components/Questions/Erklaerung";
import Location from "@lib/components/Questions/Location";
import PrivacyQuestion from "@lib/components/Questions/PrivacyQuestion";
import CGM from "@lib/components/Questions/CGM";
import Contact from "@lib/components/Questions/Contact";
import Upload from "@lib/components/Questions/Upload";
import AnswerSummary from "@lib/components/AnswerSummary";
import {
  IonGrid,
  // IonRow,
  // IonCol,
  // IonIcon,
  // IonButton,
  modalController,
} from "@ionic/vue";
import Roodie from "@lib/components/svg/Roodie";
import { call, videocam } from "ionicons/icons";
import PhoneMedgateModal from "@arag/components/PhoneMedgateModal";
import VideoMedgateModal from "@arag/components/VideoMedgateModal";

export default {
  emits: ["nextQuestion", "edit-question"],
  components: {
    Buttons,
    Slider,
    Checkbox,
    ImageButtons,
    Gender,
    Date,
    NumberSelect,
    ImageMap,
    TextRadio,
    DateTimeInterval,
    DayTimeInterval,
    DayTimeSelection,
    // NextQuestionButton,
    IonGrid,
    // IonRow,
    // IonCol,
    Roodie,
    Tooltip,
    Erklaerung,
    Location,
    PrivacyQuestion,
    CGM,
    Contact,
    Upload,
    AnswerSummary,
    // IonIcon,
    // IonButton,
  },
  props: {
    questions: {
      required: true,
      type: Array,
    },
    questionIndex: {
      required: true,
      type: Number,
    },
    genderValue: {
      required: true,
      type: String,
    },
    selectedCondition: {
      required: true,
      type: Object,
    },
    person: {
      required: true,
      type: String,
    },
    selectedArea: {
      required: false,
      type: String,
      default: "",
    },
    roodieExpression: {
      required: false,
      type: String,
      default: "happy",
    },
    zahn: {
      required: false,
      type: Boolean,
      default: false,
    },
    herzDiabetes: {
      required: false,
      type: Boolean,
      default: false,
    },
    routing: {
      required: false,
      type: String,
      default: "",
    },
    files: {
      required: false,
      type: Array,
      default: null,
    },
    userFiles: {
      required: false,
      type: Array,
      default: null,
    },
    partnerFiles: {
      required: false,
      type: Array,
      default: null,
    },
    questionsObject: {
      required: true,
      type: Object,
    },
    answers: {
      required: true,
      type: Array,
    },
    answersObject: {
      required: false,
      type: Object,
      default: null,
    },
    selectedSentence: {
      required: false,
      type: String,
      default: "",
    },
    mental: {
      required: false,
      type: Boolean,
      default: false,
    },
    shouldOpenInteliwiseModal: {
      required: false,
      type: Boolean,
      default: false,
    },
    shouldStepBack: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      showInfoAlt: false,
      previousQuestionIndex: 0,
    };
  },
  watch: {
    questionIndex(newVal, oldVal) {
      this.previousQuestionIndex = oldVal;
    },
  },
  setup() {
    return { call, videocam };
  },
  methods: {
    getTransitionName() {
      // if (question.type === "answerSummary") {
      //   return this.previousQuestionIndex < this.questionIndex
      //     ? "fade"
      //     : "fade-back";
      // }
      return this.previousQuestionIndex < this.questionIndex
        ? "slide"
        : "slide-back";
    },
    async openPhoneMedgateModal() {
      const modal = await modalController.create({
        component: PhoneMedgateModal,
        cssClass: "c-autoheight-modal",
      });
      return modal.present();
    },
    async openVideoMedgateModal() {
      const modal = await modalController.create({
        component: VideoMedgateModal,
        cssClass: "c-autoheight-modal",
      });
      return modal.present();
    },
    getQuestionText(question) {
      let result = "";
      const textKey = this.showInfoAlt ? "textAlt" : "text";
      if (typeof question[textKey] === "object") {
        if (question[textKey].zahn && this.zahn) {
          result = question[textKey].zahn;
        } else if (question[textKey].all) {
          result = question[textKey].all;
        }
      } else {
        result = question[textKey];
      }
      return result;
    },
    getTooltipText(index) {
      let result = "";
      const infoKey = this.showInfoAlt ? "infoAlt" : "info";
      if (this.questions[index][infoKey]) {
        result = this.questions[index][infoKey];
        if (result.text) {
          if (typeof result.text === "object") {
            if (result.text.zahn && this.zahn) {
              result = result.text.zahn;
            } else if (result.text.all) {
              result = result.text.all;
            }
          } else {
            result = result.text;
          }
        }
      }
      return result;
    },
    getTooltipImage(index) {
      let result = "";
      const infoKey = this.showInfoAlt ? "infoAlt" : "info";
      if (this.questions[index][infoKey]?.image) {
        result = this.questions[index][infoKey].image;
        if (typeof result === "object") {
          if (result.zahn && this.zahn) {
            result = result.zahn;
          } else if (result.all) {
            result = result.all;
          }
        }
      }
      return result;
    },
  },
};
</script>

<style lang="scss">
.c-questions-list {
  height: 100%;
  position: relative;

  &__question {
    min-height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;

    &.-imagemap {
      height: 100%;
    }
  }

  &__imagemap {
    flex-grow: 1;
    min-height: 0;
  }

  &__answer {
    width: 90%;
    margin-left: auto;

    @media screen and (min-width: $breakpoint-md) {
      width: 60%;
    }
  }

  ion-button {
    text-align: right;
  }
}
</style>
